import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cars"
export default class extends Controller {
  showReviews(event) {
    console.log("showReviews")
    event.preventDefault();
    document.getElementById("tab-panel-reviews").classList.remove("hidden");
    document.getElementById("tab-panel-car-info").classList.add("hidden");
    document.getElementById("tab-panel-faq").classList.add("hidden");
  }
  showCarInfo(event) {
    console.log("showCarInfo")
    event.preventDefault();
    document.getElementById("tab-panel-car-info").classList.remove("hidden");
    document.getElementById("tab-panel-reviews").classList.add("hidden");
    document.getElementById("tab-panel-faq").classList.add("hidden");
  }
  showFaqs(event) {
    console.log("showFaqs")
    event.preventDefault();
    document.getElementById("tab-panel-faq").classList.remove("hidden");
    document.getElementById("tab-panel-reviews").classList.add("hidden");
    document.getElementById("tab-panel-car-info").classList.add("hidden");
  }

  insuranceModal(event) {
    event.preventDefault();
    document.getElementById("insurance_modal").classList.toggle("hidden");
  }
}
